import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// ws(s)://host/api — for live wall updates
export const WS_API = API.replace(/^http/, "ws");

// MR (medical rep) session — used by the gated pledge flow.
const MR_TOKEN_KEY = "hip_mr_token";
const MR_INFO_KEY = "hip_mr_info";

export const mrSession = {
  token: () => localStorage.getItem(MR_TOKEN_KEY),
  info: () => {
    try { return JSON.parse(localStorage.getItem(MR_INFO_KEY)) || null; } catch { return null; }
  },
  save: (token, info) => {
    localStorage.setItem(MR_TOKEN_KEY, token);
    localStorage.setItem(MR_INFO_KEY, JSON.stringify(info));
  },
  update: (info) => localStorage.setItem(MR_INFO_KEY, JSON.stringify(info)),
  clear: () => {
    localStorage.removeItem(MR_TOKEN_KEY);
    localStorage.removeItem(MR_INFO_KEY);
  },
};

export const mrApi = axios.create({ baseURL: API });
mrApi.interceptors.request.use((config) => {
  const token = mrSession.token();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hip_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Download the admin pledges Excel, optionally filtered (mr_emp_code / source_link).
// Fetches an admin-only file with the bearer token and saves it, taking the
// filename from Content-Disposition. Admin downloads can't be plain <a href>
// links because the endpoints need the Authorization header.
export function downloadAdminFile(path, params = {}, fallbackName = "download") {
  const token = localStorage.getItem("hip_admin_token");
  const qs = new URLSearchParams(params).toString();
  return fetch(`${API}${path}${qs ? `?${qs}` : ""}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((r) => {
      if (!r.ok) {
        // Carry the status so callers can tell "nothing there" (404) from a
        // genuine failure.
        const err = new Error("download failed");
        err.status = r.status;
        throw err;
      }
      const filename = (r.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/)?.[1]
        || fallbackName;
      return r.blob().then((blob) => ({ blob, filename }));
    })
    .then(({ blob, filename }) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    });
}

export function downloadAdminExport(params = {}) {
  return downloadAdminFile("/admin/export", params, "healthy-india-pledges.xlsx");
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
